<template>
  <a-layout class="full-window">
    <a-layout-content><slot></slot></a-layout-content>
    <a-layout-footer height="97">
      <slot name="footer"></slot>
      <a-row>
        <foot-notes></foot-notes>
      </a-row>
    </a-layout-footer>
  </a-layout>
</template>
<script lang="ts" setup>
import FootNotes from '@/components/core/foot-notes.vue'
defineOptions({
  name: 'AuthLayout',
  displayName: 'AuthLayout',
})
</script>
<style scoped>
#footer-content {
  height: 20px;
}
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.3s;
}

.fade-transform-enter-from {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
